export default "__VITE_ASSET__CH1C005X__"